// extracted by mini-css-extract-plugin
export default {"leadersWrapper":"_Leaders_leadersWrapper__BPwT4","leader":"_Leaders_leader__AdMWU","leaderPhoto":"_Leaders_leaderPhoto__fBUgq","leaderSocials":"_Leaders_leaderSocials__Zm39g"};